import type { ModuleSlot, ModuleView, UnitView } from "./types.js";

export const SHEET_SLOTS: readonly ModuleSlot[] = ["weapon", "armor", "core", "sensor", "drive"];

/** What Auto-equip could do for this unit right now: how many slots are empty and how many of them have a free depot module (D69). */
export function autoEquipOffer(unit: Pick<UnitView, "modules">, depot: readonly Pick<ModuleView, "slot" | "unitRowId">[]): { emptySlots: number; candidates: number } {
  const filled = new Set(unit.modules.map((m) => m.slot));
  const free = new Set(depot.filter((m) => m.unitRowId === null).map((m) => m.slot));
  let emptySlots = 0;
  let candidates = 0;
  for (const slot of SHEET_SLOTS) {
    if (filled.has(slot)) continue;
    emptySlots++;
    if (free.has(slot)) candidates++;
  }
  return { emptySlots, candidates };
}

/** New units from a draw that Auto-equip could dress: only rows with an empty slot for which a free module exists. */
export function autoEquipTargets(units: readonly Pick<UnitView, "id" | "modules">[], depot: readonly Pick<ModuleView, "slot" | "unitRowId">[]): string[] {
  return units.filter((u) => autoEquipOffer(u, depot).candidates > 0).map((u) => u.id);
}
